// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SafetyOutlinedSvg from "@ant-design/icons-svg/es/asn/SafetyOutlined";
import AntdIcon from '../components/AntdIcon';

var SafetyOutlined = function SafetyOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SafetyOutlinedSvg
  }));
};

SafetyOutlined.displayName = 'SafetyOutlined';
export default React.forwardRef(SafetyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SafetyOutlined.js
// module id = 1745
// module chunks = 0